import React from 'react';

import { Element, Icon, Color, Size } from '@americanexpress/aqx-components';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';

const WhatYouEarn = ({ content, styles }) => {
  const { header, icon } = content;
  return (
    <Element className={styles.whatYouEarn}>
      <Icon
        directory="dls"
        hiddenToScreenReaders="true"
        imageName={icon}
        $size={Size.MD}
        theme={{
          color: Color.DeepBlue
        }}
      />
      <Sanitizer className={styles.whatYouEarnHeader} safelySetInnerHTML={header} />
    </Element>
  );
};

export default WhatYouEarn;
